import { render, staticRenderFns } from "./baas.vue?vue&type=template&id=f49c47e2&scoped=true"
import script from "./baas.vue?vue&type=script&lang=js"
export * from "./baas.vue?vue&type=script&lang=js"
import style0 from "./baas.vue?vue&type=style&index=0&id=f49c47e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f49c47e2",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/baas.vue
// module id = 4DvB
// module chunks = 0